import {PersonType} from '@domain/common/common';
import {User} from '@domain/user/user';
import {HostInvitationResponse} from '@domain/host/invitation/host-invitation.dto';
import {MediaDTO} from '@domain/media/media.dto';
import {MemberRole} from '@domain/member/member.dto';

export interface HostDTO extends HostAbout, HostContact {
  id: string;
  state?: HostState;
  inserted?: string;
  lastUpdated?: string;
  insertedBy?: User;
  invitation?: Partial<HostInvitationResponse>;
  canDelete?: boolean;
}

export interface UpdateHostRequest extends HostAbout, HostContact {
  state?: HostState;
  insertedBy?: User;
  invitationId?: string;
}

export interface HostAbout {
  type?: PersonType | null;
  legalForm?: LegalForm | null;
  name?: string | null;
  description?: string | null;
  logo?: MediaDTO | null;
  cover?: MediaDTO | null;
}

export interface HostContact {
  messaging?: boolean | null;
  email?: string | null;
  newEmail?: string | null;
  webUrl?: string | null;
  fbUrl?: string | null;
  igUrl?: string | null;
}

export interface HostSendMessageRequest {
  captcha: string;
  senderEmail: string;
  senderName: string;
  senderPhone?: string | null;
  subject?: string | null;
  message: string;
}

export enum HostState {
  Registered = 'Registered',
  Invited = 'Invited',
  Active = 'Active',
  Disabled = 'Disabled',
  Deleting = 'Deleting'
}

export enum LegalForm {
  Individual = 'Individual',
  Nonprofit = 'Nonprofit',
  Business = 'Business',
  Public = 'Public'
}

export interface CreateActivityForHostRequest {
  roles?: MemberRole[] | null;
}

export interface HostStats {
  nbRegistered: number,
  nbInvited: number,
  nbActive: number,
  nbWithActiveSchedule: number,
  nbWithDetailedSchedule: number,
}

